import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { TicketNote } from "@services/tickets/types";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import { FormContext } from "../context/formContext";
import Button from "@common/components/Button";

interface AddCommentDialogProps {
  open?: boolean;
  onClose?: () => void;
}

const AddCommentDialog = (props: AddCommentDialogProps) => {
  const { form, dispatchDetails, dispatchHasChanged } = useContext(FormContext);
  const { details } = form;
  const { open = false, onClose = () => {} } = props;
  const { t } = useTranslation();
  const [comment, setComment] = useState<string>("");
  const [errorComment, setErrorComment] = useState<string>("");
  const [user] = useAuthenticatedUser();

  const onConfirm = async () => {
    setErrorComment("");
    if (comment != "") {
      dispatchDetails({
        notes: [
          ...(details.notes ?? []),
          {
            note: comment,
            creator: user?.email,
            createDate: new Date().getTime(),
          },
        ],
      });
      dispatchHasChanged(true);
      setComment("");
      onClose();
    } else {
      setErrorComment(t("Field is required"));
    }
  };

  const onCancel = () => {
    setErrorComment("");
    setComment("");
    onClose();
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle>{t("Add Comment")}</DialogTitle>
      <DialogContent>
        <FormControl
          fullWidth
          sx={(theme) => ({
            marginTop: 2,
            width: "100%",
            "& .MuiFormHelperText-root": {
              color: theme.palette.error.main,
            },
            "& .MuiInputLabel-root::after": {
              content: "'*'",
              color: theme.palette.error.main,
            },
          })}
        >
          <TextField
            id="comment_textfield"
            multiline
            label={t("Comment")}
            value={comment}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setComment(e.target.value)
            }
          />
          <FormHelperText>{errorComment}</FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="white" onClick={onConfirm}>
          {t("Add Comment")}
        </Button>
        <Button variant="outlined" color="greyed" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCommentDialog;
